export enum QUOTE_STATUS {
	'874cb3d3-8afc-4022-8f36-1a65df8d1357' = 'ACTIVE',
	'edd2e47a-73a7-406b-85cc-1c339993fdd9' = 'CANCELLED',
	'0b20aa5d-f6a0-4c29-a258-05c78547ee72' = 'DRAFT',
	'753ad3ba-e4dc-4e2a-a3d4-494a483df6d3' = 'EXPIRED',
	'b3713346-bdfd-4a6a-a1ec-3bbbe8e25836' = 'FILLED',
}

export enum QUOTE_STATUS_STRING {
	'DRAFT' = 'DRAFT',
	'EXPIRED' = 'EXPIRED',
	'ACTIVE' = 'ACTIVE',
	'FILLED' = 'FILLED',
	'CANCELLED' = 'CANCELLED',
}
